/**
 * BookableResourceTypeService
 * Service for managing bookable resource types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for bookable resource type CRUD operations
 */
export class BookableResourceTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookableResourceTypeService.DEFAULT_SERVICE_PATH,
            basePath: BookableResourceTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BookableResourceTypeService.DEFAULT_SERVICE_PATH = 'booking-management';
BookableResourceTypeService.BASE_PATH = 'api/bookable-resource-types';
//# sourceMappingURL=BookableResourceTypeService.js.map